import Settings from "../../services/settings.service";
import ModuleVersion from "./moduleVersion";

const checkVersion = () => {
    switch (Settings.version) {
        case "_kw_onboard":
            return "kw"
    //    case "latum":
    //         return "latum"
        default:
            return "ksa"
    }
}

const version = checkVersion();


const checkType = (path) => {
    if (ModuleVersion[version][path] === "_ksa") {
        return { isKSA: true, isKW: false, isLatum: false }
    }
    if (ModuleVersion[version][path] === "_kw_onboard") {
        return { isKSA: false, isKW: true , isLatum: false}
    }
    // if (ModuleVersion[version][path] === "latum") {
    //     return { isKSA: false, isKW: true ,isLatum: false }
    // }
}

var checkModule = {};

checkModule.isRandomKw = checkType("Random").isKW

checkModule.isRandomKsa = checkType("Random").isKSA

checkModule.isNumberSearchKw = checkType("NumberSearch").isKW

checkModule.isNumberSearchKsa = checkType("NumberSearch").isKSA

checkModule.isEligibilityKw = checkType("Eligibility").isKW

checkModule.isEligibilityKsa = checkType("Eligibility").isKSA

checkModule.isCategoryKw = checkType("Category").isKW

checkModule.isCategoryKsa = checkType("Category").isKSA

checkModule.isCreateAccountKw = checkType("CreateAccount").isKW

checkModule.isCreateAccountKsa = checkType("CreateAccount").isKSA

checkModule.isPlanKw = checkType("PlanSelection").isKW

checkModule.isPlanKsa = checkType("PlanSelection").isKSA

checkModule.isFooterKw = checkType("Footer").isKW

checkModule.isFooterKsa = checkType("Footer").isKSA

checkModule.isSimSelectionKw = checkType("SimSelection").isKW

checkModule.isSimSelectionKsa = checkType("SimSelection").isKSA

checkModule.isHeaderKw = checkType("Header").isKW

checkModule.isHeaderKsa = checkType("Header").isKSA

checkModule.isTopUpKw = checkType("TopUp").isKW

checkModule.isTopUpKsa = checkType("TopUp").isKSA

checkModule.isStorePickUpKw = checkType("StorePickUp").isKW
checkModule.isStorePickUpKsa = checkType("StorePickUp").isKSA

checkModule.isActivateSimTabKw = checkType("ActivateSimTab").isKW
checkModule.isActivateSimTabKsa = checkType("ActivateSimTab").isKSA

checkModule.isMnpKw = checkType("Mnp").isKW

checkModule.isMnpKsa = checkType("Mnp").isKSA

checkModule.isSummaryKw = checkType("Summary").isKW

checkModule.isSummaryKsa = checkType("Summary").isKSA

checkModule.isAppVariableKsa = checkType("isAppVariable").isKSA

checkModule.isAppVariableKw = checkType("isAppVariable").isKW
checkModule.isPaymentKw = checkType("Payment").isKW

checkModule.isPaymentKsa = checkType("Payment").isKSA
checkModule.isDropOffKw = checkType("DropOff").isKW
checkModule.isDropOffKsa = checkType("DropOff").isKSA


// checkModule.isRandomLatum = checkType("Random").isLatum

export default checkModule;






